__turbopack_context__.v({
  "backHomeButton": "HS70Aa_backHomeButton",
  "notFoundContainer": "HS70Aa_notFoundContainer",
  "notFoundContent": "HS70Aa_notFoundContent",
  "notFoundDescription": "HS70Aa_notFoundDescription",
  "notFoundImage": "HS70Aa_notFoundImage",
  "notFoundSubtitle": "HS70Aa_notFoundSubtitle",
  "notFoundSuggestions": "HS70Aa_notFoundSuggestions",
  "notFoundTitle": "HS70Aa_notFoundTitle",
  "suggestionLink": "HS70Aa_suggestionLink",
  "suggestionLinks": "HS70Aa_suggestionLinks",
});
